import React from "react";
import { motion } from "framer-motion";
import { Upload, Wand2, MailCheck } from "lucide-react";

const steps = [
  {
    n: "01",
    title: "Upload your old CV",
    desc: "Send us your existing resume or share your information through a simple form.",
    Icon: Upload,
  },
  {
    n: "02",
    title: "AI creates & optimizes",
    desc: "Our engine rewrites, restructures, and visually crafts your CV for maximum impact.",
    Icon: Wand2,
  },
  {
    n: "03",
    title: "Receive your professional CV",
    desc: "Get a polished, ATS-ready PDF — ready to send to recruiters immediately.",
    Icon: MailCheck,
  },
];

export const HowItWorks = () => {
  return (
    <section
      id="how"
      className="relative py-24 sm:py-32"
      data-testid="how-it-works-section"
    >
      <div
        aria-hidden
        className="absolute inset-x-0 top-1/2 -translate-y-1/2 h-px bg-gradient-to-r from-transparent via-white/10 to-transparent"
      />
      <div className="relative mx-auto max-w-6xl px-4 sm:px-6 lg:px-8">
        <div className="max-w-2xl">
          <p className="text-xs uppercase tracking-[0.18em] text-zinc-500">
            How it works
          </p>
          <h2
            className="mt-3 text-3xl md:text-4xl font-semibold tracking-tight text-white text-balance"
            data-testid="how-headline"
          >
            Three simple steps. One unforgettable resume.
          </h2>
        </div>

        <div className="mt-14 grid grid-cols-1 md:grid-cols-3 gap-4 md:gap-6">
          {steps.map(({ n, title, desc, Icon }, idx) => (
            <motion.div
              key={n}
              initial={{ opacity: 0, y: 16 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ delay: idx * 0.08 }}
              className="relative rounded-2xl border border-white/10 bg-zinc-950/50 p-6 overflow-hidden"
              data-testid={`how-step-${idx}`}
            >
              <div className="flex items-center justify-between">
                <span className="text-xs text-zinc-500 font-mono">{n}</span>
                <Icon className="h-4 w-4 text-zinc-500" />
              </div>
              <h3 className="mt-6 text-lg font-medium text-white">{title}</h3>
              <p className="mt-2 text-sm text-zinc-400 leading-relaxed">
                {desc}
              </p>
              <div
                aria-hidden
                className="absolute -bottom-16 -right-16 h-40 w-40 rounded-full bg-blue-500/10 blur-3xl"
              />
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};
